<template>
  <div class="field">
    <Nav class="chat-btn" />
    <VInput v-model="inputValue" class="chat-input" />
    <Attachment v-if="isAttachment && hasNoValueInInput" class="chat-btn" />

    <v-btn
      @click="showTranslate" v-if="googleTranslate" 
      large icon 
      :color="bgColor"
      :style="{ color: btnBgColor }"
      >
      <v-icon>{{ mdiGoogleTranslate }}</v-icon>
    </v-btn>

    <v-dialog v-model="isTranslate" eager max-width="320">
      <div class="modal modal-window">
        <div
          icon
          @click="isTranslate = false"
          :style="{ color: defaultFontColor }"
          class="modal-window__close-button"
        >
          <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.43652 3.64258L6.52832 0.046875H8.52441L5.5166 4.98242L8.59277 10H6.57617L4.43652 6.34961L2.29004 10H0.280273L3.36328 4.98242L0.348633 0.046875H2.34473L4.43652 3.64258Z" fill="#3A3A3A"/></svg>
        </div>

        <div v-if="googleTranslate" class="translate" id="google_translate_element"></div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiGoogleTranslate } from '@mdi/js';
import VInput from './Input';
import Attachment from './Attachment';
import Nav from './Nav';
import { mdiClose } from '@mdi/js';

export default {
  name: 'ChatInput',
  components: {
    VInput,
    Attachment,
    Nav
  },
  data() {
    return {
      isTranslate: false,
      mdiGoogleTranslate,
      mdiClose,
      inputValue: null,
    };
  },
  methods: {
    showTranslate() {
      this.isTranslate = true;
    }
  },
  computed: {
    ...mapGetters({
      isAttachment: 'theme/isAttachment',
    }),
    hasNoValueInInput() {
      return !this.inputValue || this.inputValue?.trim() === '';
    },
    bgColor() {
      return this.$store.getters['theme/theme']?.common?.bgColor;
    },
    defaultFontColor() {
      return this.$store.getters['theme/theme'].common?.fontColor;
    },
    btnBgColor() {
      return this.$store.getters['theme/btnBgColor'];
    },
    googleTranslate() {
      return this.$store.getters['theme/isGoogleTranslate'];
    }
  }
};
</script>

<style lang="scss" scoped>
  .field {
    display: flex;
    // border: solid 1px #333;
    border: 1px solid #D8D8D8;
    background: #fff;
    border-radius: 25em;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.02);
    height: 50px;
    padding: 0 6px;
    align-items: center;

    .chat-input {
      margin-left: 1rem;
      width: 100%;
    }
    .chat-btn {
      display: flex;
      align-items: center;
    }
  }

  .translate {
    background: #fff;
    padding: $content-padding-x 0;
    text-align: center;
  }

  .button {
    background: #f3f3f3;
    width: 36px;
    height: 36px !important;
    margin-left: 4px;
  }
  
</style>
